import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "#/lib/api";
import type {
  BillingStatusResponse,
  CheckoutInterval,
  CheckoutResponse,
  PortalResponse,
} from "@myapp/shared";

export async function fetchBillingStatus(): Promise<BillingStatusResponse> {
  const { data } = await api.get<BillingStatusResponse>("/billing/status");
  return data;
}

export async function createCheckout(
  interval: CheckoutInterval,
): Promise<CheckoutResponse> {
  const { data } = await api.post<CheckoutResponse>("/billing/checkout", {
    interval,
  });
  return data;
}

export async function createPortalSession(): Promise<PortalResponse> {
  const { data } = await api.post<PortalResponse>("/billing/portal");
  return data;
}

export function useBillingStatus(enabled = true) {
  return useQuery({
    queryKey: ["billing", "status"],
    queryFn: fetchBillingStatus,
    enabled,
    staleTime: 30_000,
  });
}

export function useCheckout() {
  return useMutation({
    mutationFn: createCheckout,
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
}

export function usePortal() {
  return useMutation({
    mutationFn: createPortalSession,
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
}

export function formatNextFreeAt(nextFreeAt?: string): string | null {
  if (!nextFreeAt) return null;
  const date = new Date(nextFreeAt);
  return date.toLocaleDateString(undefined, {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
}
